import { normalizeTaskKey } from "./criticalPathSortUtils";

/** Busca tarea en TaskStatus de fila muestra (nombre flexible). */
export function findMuestraTask(row, taskName) {
  if (!Array.isArray(row?.TaskStatus)) return null;
  const want = normalizeTaskKey(taskName);
  return (
    row.TaskStatus.find((t) => normalizeTaskKey(t?.name) === want) ?? null
  );
}

/** Normaliza fila API muestras → fila compatible con grid CP. */
export function normalizeMuestraRow(r) {
  const idMuestra = r.ID_MUESTRA;
  return {
    ...r,
    id: `M_${idMuestra}`,
    ID_MUESTRA: idMuestra,
    ProductId: null,
    CLiente: r.MarcaNombre,
    MarcaNombre: r.MarcaNombre,
    ProveedorNombre: r.ProveedorNombre,
    DiseñoMuestra: r.NombreEntidad,
    designCliente: r.Cliente,
    NumeroPresupuesto: `M-${idMuestra}`,
    PresupuestoEstado: "MUESTRA",
    FechaAceptacion: r.FechaAceptacion || r.FECHA_PREVISTA || r.createdAt,
    ETDF: r.FECHA_PREVISTA ? { ExpectedDate: r.FECHA_PREVISTA } : null,
    "Fabrics and trims In-house": r.FECHA_RECEPCION
      ? { ExpectedDate: r.FECHA_RECEPCION }
      : null,
    logistics: [],
  };
}

/** Agrupa filas planas de timeline muestra por ID_MUESTRA. */
export function groupMuestras(rows) {
  const map = new Map();
  (Array.isArray(rows) ? rows : []).forEach((r) => {
    const key = r.ID_MUESTRA;
    if (!map.has(key)) {
      map.set(key, {
        ...normalizeMuestraRow(r),
        TaskStatus: [],
      });
    }
    map.get(key).TaskStatus.push({
      name: r.TaskName,
      expected: r.ExpectedDate,
      updated: r.UpdatedDate,
      real: r.RealDate,
      createdAt: r.createdAt,
    });
  });
  return Array.from(map.values());
}
